import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

import adminAPi from "../../../../utils/adminAPi";
import { FeAutocomplete } from "../../../FormElements";
import FeTextField from "../../../FormElements/FeTextField";

import { debounce, isEmpty, isNumber } from "lodash";
import { updateObjectValue } from "../../../../utils/helper";
import FeDesktopDatePicker from "../../../FormElements/FeDesktopDatePicker";
import dayjs from "dayjs";

const bloodGroupOptions = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];

const PatientDemography = ({ onStateChange, editedObj, pObj, updatedObj }) => {
  const [disList, setDisList] = useState([]);
  const [thanaList, setThanaList] = useState([]);
  const [socioList, setSocioList] = useState([]);
  const [contraList, setContraList] = useState([]);
  const [breastList, setBreastList] = useState([]);
  const disRef = useRef(null);
  const thanaRef = useRef(null);
  const [covidList, setCovidList] = useState([]);
  const [thanaName, setThanaName] = useState(null);
  const [disName, setDisName] = useState(null);
  const [disValue, setDisValue] = useState(null);
  const [thanaValue, setThanaValue] = useState(null);
  const [obj, setObj] = useState({
    marital_status: null,
    blood_group: null,
    area: null,
    police_station: null,
    district: null,
    socio_economic_status: null,
    family_member: null,
    age_of_marriage: null,
    age_of_first_child: null,
    contraceptive_method: null,
    age_of_menarche: null,
    age_of_menopause: null,
    regular_irregular_menstruation: null,
    breast_examination: null,
    breast_examination_value: null,
    exercise_per_week: null,
    dietary_habit: null,
    height: null,
    weight: null,
    bmi: null,
    h_o_alcoholism: null,
    h_o_hrt: null,
    breastfeeding_duration: null,
    rt_to_chest: null,
    cancer_history: null,
    known_mutation: null,
    type: null,
    covid_histories: [
      {
        status: null,
        date: null,
        vaccine_name: null,
        vaccination_dose: null,
      },
    ],
    tb_histories: [
      {
        status: null,
        date: null,
        treatment: null,
      },
    ],
    smoking_histories: [
      {
        status: null,
        per_day: null,
        duration_in_year: null,
        packs_per_year: null,
        quit_period: null,
      },
    ],
  });

  useEffect(() => {
    getCovidList();

    return () => {};
  }, []);

  const getCovidList = async () => {
    const { data } = await adminAPi.get(
      "admin/covid-vaccine-company-records-all"
    );
    setCovidList(data.data);
  };

  const handleArrayChange = (key, name, value) => {
    const arr = [...obj[key]];

    arr[0][name] = value;
    setObj({ ...obj, [key]: arr });
  };

  useEffect(() => {
    let u = null,
      e = null;
    if (updatedObj) {
      u = updateObjectValue(obj, updatedObj);
    }
    if (pObj) {
      e = updateObjectValue(obj, pObj);
    }

    if (u) {
      setTimeout(() => {
        setObj(u);
        if (u.district) {
          setDisValue({ district: u.district });
        }
        if (u.police_station) {
          setThanaValue({
            district: u.district,
            name: u.police_station,
          });
        }
      }, 100);
      return;
    } else if (!u && e) {
      setTimeout(() => {
        setObj(e);
        if (e.district) {
          setDisValue({ district: u.district });
        }
        if (e.police_station) {
          setThanaValue({
            district: u.district,
            name: u.police_station,
          });
        }
      }, 100);
    }
  }, [pObj, updatedObj]);
  function cleanObject(obj) {
    if (Array.isArray(obj)) {
      return obj
        .map((item) => cleanObject(item)) // Recursively clean each object in the array
        .filter(
          (item) =>
            Object.values(item).some((value) => value !== null && value !== "") // Keep object if at least one value is not empty or null
        );
    } else if (obj !== null && typeof obj === "object") {
      return Object.keys(obj).reduce((acc, key) => {
        const value = cleanObject(obj[key]);

        // Check if value is not null or empty and not an empty object/array
        if (
          value !== null &&
          value !== "" &&
          (typeof value !== "object" || Object.keys(value).length > 0)
        ) {
          acc[key] = value;
        }

        return acc;
      }, {});
    }

    return obj; // Return primitive values (non-object/non-array)
  }
  useEffect(() => {
    const cle = cleanObject(obj);

    if (!isEmpty(cle)) onStateChange(obj);
  }, [obj]);
  const changeFormValue = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    setObj({ ...obj, [name]: value });
  };

  useEffect(() => {
    getDisList(disName);

    return () => {};
  }, [disName]);
  useEffect(() => {
    getThanaList(disName, thanaName);

    return () => {};
  }, [disName, thanaName]);

  const getDisList = (name) => {
    adminAPi
      .get(`admin/districts?district=${name ? name : ""}`)
      .then((response) => {
        setDisList(response.data.data);
      })
      .catch((error) => {
        console.log(error.response);
      });
  };
  const getThanaList = (disName, thanaName) => {
    console.log("DISSS", disName, thanaName);
    if (disName)
      adminAPi
        .get(
          `admin/police-stations?district_name=${disName ? disName : ""}&name=${
            thanaName ? thanaName : ""
          }`
        )
        .then((response) => {
          console.log("response", response.data.data);
          setThanaList(response.data.data.data);
        })
        .catch((error) => {
          console.log(error.response);
        });
  };
  useEffect(() => {
    getSocioStatus();
    getContraList();
    getBreastExamList();

    return () => {};
  }, []);

  async function getSocioStatus(id) {
    const { data } = await adminAPi.get(
      `admin/socio-economic-status-records-all`
    );
    setSocioList(data.data);
    console.log("DKDSJDFS", data);
  }

  async function getContraList(id) {
    const { data } = await adminAPi.get(
      `admin/contraceptive-method-records-all`
    );
    setContraList(data.data);
  }

  async function getBreastExamList(id) {
    const { data } = await adminAPi.get(
      `admin/breast-examination-value-records-all`
    );
    setBreastList(data.data);
  }

  const handleChangeInput = (name, value) => {
    setObj({ ...obj, [name]: value });
  };
  const calculatePacksPerYear = (
    cigarettesPerDay,
    yearsSmoked,
    cigarettesPerPack = 20
  ) => {
    if (cigarettesPerDay < 0 || yearsSmoked < 0) {
      // throw new Error(
      //   "The number of cigarettes per day and years smoked must be non-negative."
      // );
      return 0;
    }

    const packsPerDay = cigarettesPerDay / cigarettesPerPack;
    const packsPerYear = packsPerDay * yearsSmoked;

    return Math.round(packsPerYear);
  };
  return (
    <>
      {" "}
      <span style={{ display: "none" }}>{JSON.stringify(obj)}</span>
      <Grid item sm={4}>
        <FeAutocomplete
          //  disabled={editedObj}
          label="Marital Stattus"
          value={obj.marital_status}
          options={["Unmarried", "Married", "Divorced", "Widowed"]}
          onChange={(event, v) => {
            const name = "marital_status";
            const value = v;
            let e = { target: { name, value } };
            changeFormValue(e);
          }}
        />
      </Grid>
      <Grid item sm={4}>
        <FeAutocomplete
          //  disabled={editedObj}
          label="Blood Group"
          value={obj.blood_group}
          options={bloodGroupOptions}
          onChange={(event, v) => {
            const name = "blood_group";
            const value = v;
            let e = { target: { name, value } };
            changeFormValue(e);
          }}
        />
      </Grid>
      <Grid item sm={4}>
        <FeTextField
          //  disabled={editedObj}
          name="area"
          label="Area"
          value={obj.area}
          onChange={changeFormValue}
        />
      </Grid>
      <Grid item xs={6} md={4}>
        <Box mb={2}>
          <FeAutocomplete
            freeSolo
            //  disabled={editedObj}
            forcePopupIcon={true}
            value={disValue}
            key={disValue}
            // disabled={!divId}
            options={disList}
            onChange={(e, v) => {
              if (!v) {
                setDisValue(v);
                setThanaValue(v);
                setThanaName(v);
                handleChangeInput("district", v);
                handleChangeInput("police_station", v);
                getDisList(null);

                return;
              }
              setThanaValue(null);
              setDisValue(v);
              disRef.current = v;
              setDisName(v.district);

              handleChangeInput("district", v.district);

              getThanaList(v.district, null);
            }}
            onInputChange={debounce((e, v, r) => {
              if (r === "input") {
                setDisName(v);
              } else if (r === "clear") {
              }
            }, 1000)}
            getOptionLabel={(option) => {
              return option.district || "";
            }}
            id="ConsultantPrimaryPhisician"
            label="District"
          />
        </Box>
      </Grid>
      <Grid item xs={6} md={4}>
        <Box mb={2}>
          <FeAutocomplete
            //  disabled={editedObj}
            forcePopupIcon={true}
            freeSolo
            // disabled={!disId}
            value={thanaValue}
            key={thanaValue}
            options={thanaList}
            onChange={(e, v) => {
              if (!v) {
                setThanaValue(v);
                handleChangeInput("police_station", v);
                getThanaList(disName, null);

                return;
              }
              setThanaValue(v);
              handleChangeInput("police_station", v.name);
            }}
            onInputChange={debounce((e, v, r) => {
              if (r === "input") {
                console.log("VVVV", v);
                setThanaName(v);
              } else if (r === "clear") {
              }
            }, 1000)}
            getOptionLabel={(option) => {
              return option.name || "";
            }}
            id="ConsultantPrimaryPhisician"
            label="Thana"
          />
        </Box>
      </Grid>
      <Grid item sm={4}>
        <FeAutocomplete
          //  disabled={editedObj}
          label="Socio-Economic Status"
          value={obj.socio_economic_status}
          options={socioList.map((o) => o.name)}
          onChange={(event, v) => {
            const name = "socio_economic_status";
            const value = v;
            let e = { target: { name, value } };

            changeFormValue(e);
          }}
        />
      </Grid>
      {/* <Grid item sm={4}>
        <FeTextField
          //  disabled={editedObj}
          name="family_member"
          label="No of Family Member"
          value={obj.family_member}
          onChange={changeFormValue}
        />
      </Grid> */}
      {/* <Grid item sm={4}>
        <FeTextField
          //  disabled={editedObj}
          name="exercise_per_week"
          label="Hours of Physical Exercise/week"
          value={obj.exercise_per_week}
          onChange={changeFormValue}
        />
      </Grid> */}
      <Grid item sm={4}>
        <FeTextField
          //  disabled={editedObj}
          name="dietary_habit"
          label="Dietary Habit"
          value={obj.dietary_habit}
          onChange={changeFormValue}
        />
      </Grid>
      <Grid item sm={4}>
        <FeTextField
          //  disabled={editedObj}
          name="height"
          label="Height (cm)"
          value={obj.height}
          onChange={changeFormValue}
        />
      </Grid>
      <Grid item sm={4}>
        <FeTextField
          //  disabled={editedObj}
          name="weight"
          label="Weight (kg)"
          value={obj.weight}
          onChange={changeFormValue}
        />
      </Grid>
      <Grid item sm={4}>
        <FeAutocomplete
          //  disabled={editedObj}
          label="H/O Alcoholism"
          value={obj.h_o_alcoholism}
          options={["Yes", "No"]}
          onChange={(event, v) => {
            const name = "h_o_alcoholism";
            const value = v;
            let e = { target: { name, value } };
            changeFormValue(e);
          }}
        />
      </Grid>
      {/* <Grid item sm={4}>
        <FeTextField
          //  disabled={editedObj}
          name="h_o_hrt"
          label="Any H/O HRT"
          value={obj.h_o_hrt}
          onChange={changeFormValue}
        />
      </Grid> */}
      <Grid item sm={4}>
        <FeTextField
          //  disabled={editedObj}
          name="rt_to_chest"
          label="Any H/O RT to chest"
          value={obj.rt_to_chest}
          onChange={changeFormValue}
        />
      </Grid>
      <Grid item sm={4}>
        <FeTextField
          //  disabled={editedObj}
          name="cancer_history"
          label="Personal/Family H/) of Cancer"
          value={obj.cancer_history}
          onChange={changeFormValue}
        />
      </Grid>
      <Grid item sm={4}>
        <FeTextField
          //  disabled={editedObj}
          name="known_mutation"
          label="Any Known Mutation"
          value={obj.known_mutation}
          onChange={changeFormValue}
        />
      </Grid>
      <Grid item sm={4}>
        <FeAutocomplete
          //  disabled={editedObj}
          label="Type"
          value={obj.type}
          options={["Local", "Foreign", "Other"]}
          onChange={(event, v) => {
            const name = "type";
            const value = v;
            let e = { target: { name, value } };
            changeFormValue(e);
          }}
        />
      </Grid>
      <Grid item sm={12} container spacing={2}>
        <Grid item sm={12}>
          <Typography variant="h6">Smoking History</Typography>
        </Grid>
        <Grid item sm={3}>
          <FeAutocomplete
            //  disabled={editedObj}
            label="Status"
            value={obj?.smoking_histories?.[0]?.status}
            options={["Yes", "No", "Former Smoker", "Passive Smoker"]}
            onChange={(event, v) => {
              const key = "smoking_histories";
              const name = "status";
              const value = v;
              handleArrayChange(key, name, value);
            }}
          />
        </Grid>
        <Grid item sm={2}>
          <FeTextField
            type="number"
            //  disabled={editedObj}
            name="smoking_cigarettes_per_day"
            label="No. of Cigarettes / Day"
            value={obj?.smoking_histories?.[0]?.per_day}
            onChange={(e) => {
              if (isNumber(parseInt(e.target.value))) {
                const key = "smoking_histories";
                const name = "per_day";
                const value = e.target.value;
                handleArrayChange(key, name, value);
                handleArrayChange(
                  key,
                  "packs_per_year",
                  calculatePacksPerYear(
                    value,
                    obj?.smoking_histories?.[0]?.duration_in_year
                  )
                );
              }
            }}
          />
        </Grid>

        <Grid item sm={3}>
          <FeTextField
            type="text"
            //  disabled={editedObj}
            name="duration_in_year"
            label="Smoking For (Years)"
            value={obj?.smoking_histories?.[0]?.duration_in_year}
            onChange={(e) => {
              if (isNumber(parseInt(e.target.value))) {
                const key = "smoking_histories";
                const name = "duration_in_year";
                const value = e.target.value;
                handleArrayChange(key, name, value);
                handleArrayChange(
                  key,
                  "packs_per_year",
                  calculatePacksPerYear(
                    obj?.smoking_histories?.[0]?.per_day,
                    value
                  )
                );
              }
            }}
          />
        </Grid>
        <Grid item sm={2}>
          <FeTextField
            type="number"
            //  disabled={editedObj}
            name="smoking_packets_per_year"
            label="Pack-Year"
            value={obj?.smoking_histories?.[0]?.packs_per_year}
          />
        </Grid>
        <Grid item sm={2}>
          <FeTextField
            type="text"
            //  disabled={editedObj}
            name="duration_in_year"
            label="Quit Smoking For (Years)"
            value={obj?.smoking_histories?.[0]?.quit_period}
            onChange={(e) => {
              if (isNumber(parseInt(e.target.value))) {
                const key = "smoking_histories";
                const name = "quit_period";
                const value = e.target.value;
                handleArrayChange(key, name, value);
              }
            }}
          />
        </Grid>
      </Grid>
      <Grid item sm={12} container spacing={2}>
        <Grid item sm={12}>
          <Typography variant="h6">TB History</Typography>
        </Grid>
        <Grid item sm={3}>
          <FeAutocomplete
            //  disabled={editedObj}
            label="Status"
            value={obj?.tb_histories?.[0]?.status}
            options={["Positive", "Negative"]}
            onChange={(event, v) => {
              const key = "tb_histories";
              const name = "status";
              const value = v;
              handleArrayChange(key, name, value);
            }}
          />
        </Grid>
        <Grid item sm={4}>
          <Box
            sx={{
              "& .MuiFormControl-root": {
                width: "100%",
              },
            }}
          >
            <FeDesktopDatePicker
              //  disabled={editedObj}
              label="TB Treatment Start Date"
              inputFormat="DD/MM/YYYY"
              value={obj?.tb_histories?.[0]?.date}
              onChange={(v) => {
                const key = "tb_histories";
                const name = "date";
                const value = dayjs(v).format("YYYY-MM-DD");
                handleArrayChange(key, name, value);
              }}
            />
          </Box>
        </Grid>

        <Grid item sm={3}>
          <FeTextField
            type="text"
            //  disabled={editedObj}
            label="Treatment"
            value={obj?.tb_histories?.[0]?.treatment}
            onChange={(e) => {
              const key = "tb_histories";
              const name = "treatment";
              const value = e.target.value;
              handleArrayChange(key, name, value);
            }}
          />
        </Grid>
      </Grid>
      <Grid item sm={12} container spacing={2}>
        <Grid item sm={12}>
          <Typography variant="h6">Covid History</Typography>
        </Grid>
        <Grid item sm={3}>
          <FeAutocomplete
            //  disabled={editedObj}
            label="Status"
            value={obj?.covid_histories?.[0]?.status}
            options={["Positive", "Negative"]}
            onChange={(event, v) => {
              const key = "covid_histories";
              const name = "status";
              const value = v;
              handleArrayChange(key, name, value);
            }}
          />
        </Grid>
        <Grid item sm={3}>
          <Box
            sx={{
              "& .MuiFormControl-root": {
                width: "100%",
              },
            }}
          >
            <FeDesktopDatePicker
              //  disabled={editedObj}
              label="Date"
              inputFormat="DD/MM/YYYY"
              value={obj?.covid_histories?.[0]?.date}
              onChange={(v) => {
                const key = "covid_histories";
                const name = "date";
                const value = dayjs(v).format("YYYY-MM-DD");
                handleArrayChange(key, name, value);
              }}
            />
          </Box>
        </Grid>

        <Grid item sm={3}>
          <FeAutocomplete
            //  disabled={editedObj}
            label="Vaccine Name"
            value={obj?.covid_histories?.[0]?.vaccine_name}
            options={
              covidList.length > 0 ? covidList.map((item) => item.name) : []
            }
            onChange={(event, v) => {
              const key = "covid_histories";
              const name = "vaccine_name";
              const value = v;
              handleArrayChange(key, name, value);
            }}
          />
        </Grid>
        <Grid item sm={3}>
          <FeAutocomplete
            //  disabled={editedObj}
            label="Vaccination Dose"
            value={obj?.covid_histories?.[0]?.vaccination_dose}
            options={[
              "1st Dose",
              "2nd Dose",
              "3rd Dose",
              "4th Dose",
              "5th Dose",
            ]}
            onChange={(event, v) => {
              const key = "covid_histories";
              const name = "vaccination_dose";
              const value = v;
              handleArrayChange(key, name, value);
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PatientDemography;
